module.exports = __webpack_public_path__ + "img/dashboard_sales_orders.5119e5e.png";